<template>
    <div class="modal-card pop_min" id="draggable" style="overflow-y:hidden">
        <header class="modal-card-head pop-header">
            <button class="icon is-right" @click="move" style="position:absolute;top:18px;right:70px;z-index:30;"><i class="fas fa-window-maximize" style="color:#fff;font-size:22px;padding-top:1px"></i></button>
            <p class="modal-card-title tit">
                {{ title }}
                <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
            </p>
        </header>
        <section class="modal-card-body pop-content">
        <div class="inner-box">
            <div v-if="isNew" class="content-name" style="margin-top: 0px; margin-bottom: 0px;">
                <div class="btn-wrap btn-type1 clearfix" style="float:right; margin-bottom: 0px;">
                    <button class="btn-size btn-blue" @click="approval()">
                        <span class="btn-icon"><i class="fas fa-pen-alt"></i></span> 상신
                    </button>
                    <button class="btn-size btn-blue" @click="openLinePopup()">
                        <span class="btn-icon"><i class="fas fa-user-check"></i></span> 결재자 지정
                    </button>
                    <button class="btn-size btn-yellow" @click="openReferPopup()">
                        <span class="btn-icon"><i class="fas fa-user-plus"></i></span> 참조자 지정
                    </button>
                </div>
            </div>
            <div v-if="!isNew" class="content-name" style="margin-top: 0px; margin-bottom: 0px;">
                <div class="btn-wrap btn-type1 clearfix" style="float:right; margin-bottom: 0px;">
                    <button v-if="(this.$store.state.loginInfo.loginId === this.apprInfo.thisApprUser || this.apprInfo.deleYn ==='Y')
                                   && (this.apprInfo.docStatus === 'REQ' || this.apprInfo.docStatus === 'ING')" class="btn-size btn-blue" @click="openApprPopup()"><span class="btn-icon"><i
                            class="fas fa-pen-alt"></i></span> 결재
                    </button>
                    <button v-if="(this.$store.state.loginInfo.loginId === this.apprInfo.thisApprUser
                                   || this.$store.state.loginInfo.authorities[0].roleCd ==='ADMIN')
                                   && (this.apprInfo.docStatus === 'REQ' || this.apprInfo.docStatus === 'ING')"class="btn-size btn-blue" @click="openLinePopup()">
                       <span class="btn-icon"><i class="fas fa-user-check"></i></span> 결재선 변경
                    </button>
                    <button v-if="(this.$store.state.loginInfo.loginId === this.apprInfo.thisApprUser
                                   || this.$store.state.loginInfo.authorities[0].roleCd ==='ADMIN')
                                   && (this.apprInfo.docStatus === 'REQ' || this.apprInfo.docStatus === 'ING')" class="btn-size btn-yellow" @click="openReferPopup()">
                        <span class="btn-icon"><i class="fas fa-user-plus"></i></span> 참조자 변경
                    </button>
                    <button v-if="this.$store.state.loginInfo.loginId == this.apprInfo.draftUserId && this.apprInfo.docStatus === 'REQ'"
                            class="btn-size btn-yellow" @click="cancel(docMngNo)"><span class="btn-icon"><i class="far fa-file"></i></span> 상신취소
                    </button>
                </div>
            </div>

            <appr-dtl ref="apprDtl" v-if="isLoaded" v-model="data" :docType="docType" :approval-line.sync="apprLine"
                      :reference-line.sync="referLine" :docMngNo="docMngNo" :budReqNo="budReqNo" @input="$forceUpdate()"
                      @approvalLine="changeApprovalLineEvent" @referenceLine="changeReferLineEvent"
                      @apprInfo="apprInfoCheck"/>
        </div>
    </section>
    </div>
</template>

<script>
    import DhxGrid from '@/components/DhxGrid.vue'

    import ApprLineSet from '@/components/ApprLineSet.vue'
    import ApprReferSet from '@/components/ApprReferSet.vue'
    import ApprActPop from '@/components/ApprActPop.vue'
    import ApprDtl from '@/components/ApprDtl.vue'

    export default {
        props: {
            docMngNo: {
                type: String,
                required: false
            },
            budReqNo: {
                type: String,
                required: false
            },
            docType: {
                type: String,
                required: false,
                default: 'SLIP'
            },
            value: {
                type: Object,
                required: false,
                default() {
                  return {}
                }
            }
        },
        components: {
            ApprDtl,
            DhxGrid,
            ApprLineSet,
            ApprReferSet
        },
        data() {
            return {
                title: '결재상신',
                data: {},
                dataProp: {},
                apprHeader: {},
                apprLine: [],
                referLine: [],
                apprNo: '',
                apprSeq: '',
                docTitleNm: '',
                //docTypeCd: '',
                docStatus: '',
                draftUserId: '',
                thisApprUser: '',
                deleYn: 'N',
                apprInfo: [],
                loaded: false,
                isNew: false,
                isMxMn: true,
                apprAloneAllow: 'N'
            }
        },
        methods: {
            move() {
                if(this.isMxMn) {
                    $(".modal-card").removeClass('pop_min')
                    $(".modal-card").addClass('pop_max');

                    $(".animation-content").removeClass('pop_min')
                    $(".animation-content").addClass('pop_max');
                    this.isMxMn = false
                } else {
                    $(".modal-card").removeClass('pop_max')
                    $(".modal-card").addClass('pop_min');

                    $(".animation-content").removeClass('pop_max')
                    $(".animation-content").addClass('pop_min');
                    this.isMxMn = true
                }
            },
            checkMg() {
                let compCd = this.$store.state.loginInfo.compCd;
                if(compCd == '100002' || compCd == '100010' || compCd == '101301' || compCd == '222300') {
                    return true
                }
                return false
            },
            approval() {
                let APPR_MIN_LENGTH = this.checkMg() ? 2 : 1;
                let swalText = '결재내역을 상신합니다. 계속 하시겠습니까?'

                let apprFlag = false;
                let agreeFlag = false;
                for(let i = 0; i < this.apprLine.length; i++) {
                    if(this.apprLine[i].apprTypeCd === '20') {
                        apprFlag = true;
                        continue;
                    } else if(this.apprLine[i].apprTypeCd === '30') {
                        agreeFlag = true;
                    }
                }

                if ((this.checkMg() && !(apprFlag && agreeFlag)) || (!this.checkMg() && this.apprLine.length < APPR_MIN_LENGTH)) {
                    this.$swal({type: 'warning', text: '결재선을 지정해주세요.'});
                    return false;
                }

                this.$swal({
                    type: 'info',
                    text: swalText,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$store.commit('loading');
                        let docMngNo = ''
                        let docTitle = ''

                        if(this.docType === 'SHORT'){
                            if (this.data.visitNo.substr(0, 2) === 'VS') {
                                docMngNo = this.data.visitNo
                                docTitle = this.data.visitorComp + ' / ' + this.data.purposeNm + ' / ' + this.data.staYmd + '~' + this.data.endYmd
                            }
                        }

                        _.forEach(this.apprLine, (v, index) => {
                            v.apprSeq = index + 1
                        })

                        _.forEach(this.referLine, (v, index) => {
                            v.referSeq = index + 1
                        })

                        if(this.docType === 'SHORT') {
                            this.$http.put(`/api/appr/detail/req`, {
                                docTypeCd: this.docType,
                                docMngNo: docMngNo,
                                docTitleNm: docTitle,
                                approvalDetails: this.apprLine,
                                referDetails: this.referLine
                            }).then((response) => {
                                this.$parent.close();
                                this.$swal({type: 'info', text: '상신이 완료되었습니다.'});
                                this.$parent.$parent.status.readonly = true
                            }).catch((e) => {
                                this.$swal({type: 'error', html: e.response.data.message});
                            }).finally(() => {
                                this.$store.commit('finish')
                            })
                        }
                    }
                })
            },
            cancel(docMngNo) {
                this.$swal({
                    type: 'info',
                    text: `상신을 취소합니다. 계속 하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        if (docMngNo != undefined) {
                            this.$http.get(`/api/appr/detail/cancel/${docMngNo}`)
                                .then(response => {
                                    this.$parent.close();
                                    this.$swal({type: 'info', text: '상신 취소되었습니다.'});
                                    this.$parent.$parent.status.readonly = false
                                })
                                .catch(({message}) => {
                                    console.error(message);
                                });
                        }
                    }
                })
            },
            openLinePopup() {
                let vm = this
                this.$modal.open({
                    component: ApprLineSet,
                    props: {
                        lineList: this.apprLine
                    },
                    parent: this,
                    events: {
                        close(data) {
                            // Close event handler
                            vm.apprLine = data.lineList || []
                        }
                    }
                })
            },
            openReferPopup() {
                let vm = this
                this.$modal.open({
                    component: ApprReferSet,
                    props: {
                        lineList: this.referLine,
                        apprNo: this.docMngNo
                    },
                    parent: this,
                    events: {
                        close(data) {
                            // Close event handler
                            vm.referLine = data.lineList || []
                        }
                    }
                })
            },
            openApprPopup() {
                let vm = this
                this.$modal.open({
                    component: ApprActPop,
                    props: {
                        docTitleNm: this.apprInfo.docTitleNm,
                        apprNo: this.apprInfo.apprNo,
                        apprSeq: this.apprInfo.apprSeq
                    },
                    parent: this,
                    events: {
                        close(data) {
                            vm.$parent.close();
                            //vm.$refs.apprDtl.getAppr(data)
                            vm.$swal({type: 'info', text: '결재가 완료되었습니다.'});
                            vm.$parent.$parent.status.readonly = false
                        }
                    }
                })
            },
            changeApprovalLineEvent(data) {
                this.apprLine = data
            },
            changeReferLineEvent(data) {
                this.referLine = data
            },
            apprInfoCheck(data) {
                this.apprInfo = data
            },
            getFuncUsed() {
                this.$http.get(`/api/func/getFuncUse`, { params: { funcCd: "APPR_ALONE_YN" } })
                    .then(response => {
                        this.apprAloneYn = response.data[0].adminFuncCd;
                    });
            },

          //====================일진제강, 수원공장 방문시 자동참조인 추가 Start====================
          autoReferPerson() {
            if(this.data.compCd == "100015" && this.data.businessAreaNm == "수원공장") {
              //업무지원팀(O000000106) 인원 자동 추가
              const request1 = this.$http.get(`/api/emp/dept/O000000106`)
                  .then(response => {
                    _.forEach(response.data, v => {
                      if(this.checkDup(v.empNo) == 'N') {
                        this.referLine.push(
                            {
                              referUser : v.empNm,
                              jobNm : v.jobNm,
                              referId : v.empNo,
                              deptNm : v.deptNm,
                              referTypeCd : '40',
                              referType : '참조',
                              referNm : v.empNm,
                              compCd : v.compCd
                            }
                        )
                      }
                    })
                  });

              //안전환경팀(O000000160) 인원 자동 추가
              const request2 = this.$http.get(`/api/emp/dept/O000000160`)
                  .then(response => {
                    _.forEach(response.data, v => {
                      if(this.checkDup(v.empNo) == 'N') {
                        this.referLine.push(
                            {
                              referUser : v.empNm,
                              jobNm : v.jobNm,
                              referId : v.empNo,
                              deptNm : v.deptNm,
                              referTypeCd : '40',
                              referType : '참조',
                              referNm : v.empNm,
                              compCd : v.compCd
                            }
                        )
                      }
                    })
                  });

              // 모든 요청이 완료된 후 실행
              Promise.all([request1, request2]).then(() => {
                // 자동참조자가 있을때 알림창으로 자동참조인 확인
                if(this.referLine.length != 0) {
                  this.$swal({
                    type: 'info',
                    html: '방문하시는 사업장이 ［수원공장］일 경우, 업무지원팀과 안전환경팀이 자동으로 참조되도록 설정되어 있습니다.<br>자동 참조인 제외는 지양 부탁드립니다.',
                    width: '480px'
                  })
                }
              })

            }
          },

          checkDup(emp){
            let outYn = 'N'
            _.forEach(this.referLine, v => {
              if (v.referId === emp) {
                outYn = 'Y'
              }
            })
            return outYn;
          },
          //====================일진제강, 수원공장 방문시 자동참조인 추가 End====================

        },
        computed: {
            isLoaded() {
                return this.loaded
            }
        },
        created() {
            if(this.docMngNo === undefined) {
                this.isNew = true
            }
            else{
                this.isNew = false
                this.title = '결재보기'
            }
        },
        mounted() {
            this.getFuncUsed()

            //====================일진제강, 수원공장 방문시 자동참조인 추가 Start====================
            if(this.data.docStatCd == null){
              this.autoReferPerson();
            }
            //====================일진제강, 수원공장 방문시 자동참조인 추가 End====================

            //pop slots modal move
            $(".animation-content").addClass('pop_min');
            $(".animation-content").draggable();
            //ModalSlot open z-index change
            $('.lnb').css('z-index', '4');
        },
        destroyed() {
            //ModalSlot open z-index change
            $('.lnb').css('z-index', '7');
        },
        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(value) {
                    this.data = value
                    this.loaded = true
                }
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: auto;
    }
</style>
